import * as React from 'react';
import { QuestionTagCreateInput, QuestionTagUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useCreateQuestionTagCallback } from './useCreateQuestionTagCallback';
import { useUpdateQuestionTagCallback } from './useUpdateQuestionTagCallback';
import { QuestionTag } from '../models/QuestionTag';

/**
 * Get a callback to save a QuestionTag in the store using either a create or update.
 */
export function useSaveQuestionTagCallback(options: SaveInStoreOptions<QuestionTag, string> = {}) {
    const [_create, createStatus] = useCreateQuestionTagCallback();
    const create = React.useCallback((model: Partial<QuestionTag>) => _create(model as QuestionTagCreateInput), [_create]);

    const [_update, updateStatus] = useUpdateQuestionTagCallback();
    const update = React.useCallback((id: string, changes: Partial<QuestionTag>) => _update(id, changes as QuestionTagUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
